import styles from 'widget/event_components/ticket-spot.scss';
import cn from 'classnames';
import { isEmpty, map } from 'lodash';
import getSymbolFromCurrency from 'currency-symbol-map';
import { DiscountedPrice } from 'widget/event_components/Ticket/components/DiscountPrice';
import { PriceValue } from 'widget/event_components/Ticket/components/PriceValue';
import * as E from './elements';

export const TicketCheckoutSummaryForm = ({
  loadingCheckoutValues,
  checkoutValues,
  tickets,
  event,
  cart,
  settings,
  ticketOverrides,
  seatSelections = [],
}) => {
  const isRsvp = event.get('event_setup') === 'rsvp';

  // Group seats by ticket to show consolidated view
  const seatsByTicket = {};
  seatSelections.forEach((seat) => {
    if (seat.ticketId) {
      if (!seatsByTicket[seat.ticketId]) {
        seatsByTicket[seat.ticketId] = [];
      }
      seatsByTicket[seat.ticketId].push(seat);
    }
  });

  return (
    <E.Wrapper>
      {isEmpty(cart) && seatSelections.length === 0 && settings.get('checkoutNoTicketsSelectedText') && (
        <div className={styles.emptyCart}>
          {/* <div className="cart-summary-header">{settings.get('checkoutTicketSummaryText')}</div> */}
          <span className="no-ticket-selected">{settings.get('checkoutNoTicketsSelectedText')}</span>
        </div>
      )}

      {/* Show seats with icon */}
      {Object.entries(seatsByTicket).map(([ticketId, seats]) => {
        // Look up ticket - now includes seated tickets marked with isSeated flag
        const ticket = tickets.find((t) => String(t.get('id')) === String(ticketId));
        if (!ticket) return null;

        return (
          <E.Ticket key={`seat-${ticketId}`} className={`ticket-information ${window.isMobileType ? styles.mobileTicketInformation : ''}`}>
            <div className={styles.ticketItemQuantity}>{seats.length}x</div>
            <div className={styles.ticketItemDescription}>
              {ticket.get('name')}
              <div style={{ fontSize: '0.85em', color: '#666', marginTop: '4px' }}>{seats.map((s) => s.seatLabel).join(', ')}</div>
            </div>
            <div className={cn(styles.selection, styles.ticketItemInformations, { [styles.mobileSelection]: window.isMobileType })}>
              <>
                {settings.get('hideFreePriceLabel') || isRsvp ? null : (
                  <DiscountedPrice
                    ticket={ticket}
                    ticketOverrides={ticketOverrides}
                    currency={getSymbolFromCurrency(event.get('currency'))}
                    quantity={seats.length}
                  />
                )}
              </>
            </div>
          </E.Ticket>
        );
      })}

      {/* Show regular (manual) tickets - only display the manual quantity (total - seats) */}
      {map(cart, (quantity, ticketId) => {
        // Look up ticket - now includes all tickets (seated and non-seated)
        const ticket = tickets.find((t) => String(t.get('id')) === String(ticketId));
        if (!ticket) return null;

        // Calculate seats for this ticket
        const seatsForTicket = seatsByTicket[ticketId] || [];
        const manualQuantity = quantity - seatsForTicket.length;

        // Only show if there are manual selections (beyond seats)
        if (manualQuantity <= 0) return null;

        return (
          <E.Ticket key={`ticket-${ticketId}`} className={`ticket-information ${window.isMobileType ? styles.mobileTicketInformation : ''}`}>
            <div className={styles.ticketItemQuantity}>{manualQuantity}x</div>
            <div className={styles.ticketItemDescription}>{ticket.get('name')}</div>
            <div className={cn(styles.selection, styles.ticketItemInformations, { [styles.mobileSelection]: window.isMobileType })}>
              <>
                {settings.get('hideFreePriceLabel') || isRsvp ? null : (
                  <DiscountedPrice
                    ticket={ticket}
                    ticketOverrides={ticketOverrides}
                    currency={getSymbolFromCurrency(event.get('currency'))}
                    quantity={manualQuantity}
                  />
                )}
              </>
            </div>
          </E.Ticket>
        );
      })}
      {settings.get('hideCartSummary') || isRsvp ? null : (
        <div className={`${styles.cartSummary} ticket-price`}>
          {event.get('sales_tax') && event.get('sales_tax') > 0 ? (
            <E.TotalTextContainer>
              <E.TotalTitle>{settings.get('checkoutTicketSalesTaxText')}</E.TotalTitle>
              <PriceValue
                loadingCheckoutValues={loadingCheckoutValues}
                price={checkoutValues?.taxTotal}
                discount={0}
                currency={getSymbolFromCurrency(event.get('currency'))}
              />
            </E.TotalTextContainer>
          ) : null}
          {checkoutValues?.totalCustomBookingFees > 0 && (
            <E.TotalTextContainer>
              <div>{settings.get('checkoutBookingFeeTotalText')}</div>
              <PriceValue
                loadingCheckoutValues={loadingCheckoutValues}
                price={checkoutValues?.totalCustomBookingFees}
                discount={0}
                cartTotalBeforeDiscount={checkoutValues?.totalCustomBookingFees}
                currency={getSymbolFromCurrency(event.get('currency'))}
              />
            </E.TotalTextContainer>
          )}
          {checkoutValues?.paymentProcessingFee > 0 && (
            <E.TotalTextContainer>
              <div>{settings.get('checkoutProcessingFeeTotalText')}</div>
              <PriceValue
                loadingCheckoutValues={loadingCheckoutValues}
                price={checkoutValues?.paymentProcessingFee}
                discount={0}
                cartTotalBeforeDiscount={checkoutValues?.paymentProcessingFee}
                currency={getSymbolFromCurrency(event.get('currency'))}
              />
            </E.TotalTextContainer>
          )}
          <E.TotalTextContainer>
            <E.TotalTitle className="checkout-total-text">{settings.get('checkoutTicketTotalText')}</E.TotalTitle>
            <PriceValue
              loadingCheckoutValues={loadingCheckoutValues}
              price={checkoutValues?.cartTotal}
              discount={checkoutValues?.discount}
              cartTotalBeforeDiscount={checkoutValues?.cartTotalBeforeDiscount}
              currency={getSymbolFromCurrency(event.get('currency'))}
              className="checkout-total-value"
            />
          </E.TotalTextContainer>
        </div>
      )}
    </E.Wrapper>
  );
};
